import { useQuery } from "@tanstack/react-query";
import { Star } from "lucide-react";
import { get } from "@/lib/api";
import { CATEGORY_LABELS } from "@/lib/data";

export default function Studios() {
  const { data: studios = [] } = useQuery({ queryKey: ["admin-studios"], queryFn: () => get("/admin/studios") });

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Stüdyolar</h1>
      <p className="text-sm text-[#475569]">Toplam {studios.length} aktif stüdyo</p>

      <div className="mt-5 overflow-hidden rounded border border-[#CBD5E1] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#E2E8F0] text-left text-xs uppercase tracking-wide text-[#475569]">
            <tr><th className="px-4 py-2.5">Stüdyo</th><th className="px-4 py-2.5">Kategori</th><th className="px-4 py-2.5">Bölge</th><th className="px-4 py-2.5">Puan</th><th className="px-4 py-2.5">Kapasite</th><th className="px-4 py-2.5 text-right">Kredi</th></tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]">
            {studios.map((s) => (
              <tr key={s.id} data-testid={`admin-studio-${s.id}`} className="hover:bg-[#F8FAFC]">
                <td className="px-4 py-2.5">
                  <div className="flex items-center gap-3">
                    <img src={s.cover} alt="" className="h-8 w-8 rounded object-cover" />
                    <span className="font-medium">{s.name}</span>
                  </div>
                </td>
                <td className="px-4 py-2.5 text-[#475569]">{CATEGORY_LABELS[s.category]}</td>
                <td className="px-4 py-2.5 text-[#475569]">{s.region}</td>
                <td className="px-4 py-2.5"><span className="flex items-center gap-1 text-[#475569]"><Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" /> {s.rating}</span></td>
                <td className="px-4 py-2.5 text-[#475569]">{s.capacity}</td>
                <td className="px-4 py-2.5 text-right font-medium">{s.credit_price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
